import Vue from 'vue'

/**
 * Docket entry Mass Reassignment
 */
export const MassReassignmentState = _ => ({
  assignmentRequests: [],
})

export const MassReassignmentActions = {
  async updateAssignmentRequest ({ commit }, request) {
    commit('updateAssignmentRequest', request)
  },
}

export const MassReassignmentMutations = {
  addAssignmentRequest (state, jobId) {
    state.assignmentRequests.push({
      description: 'Pending',
      error: null,
      jobId: jobId,
      progress: null,
      visible: true,
    })
  },

  updateAssignmentRequest (state, request) {
    const idx = state.assignmentRequests.findIndex(d => d.jobId === request.job_id)
    if (idx < 0) return

    Vue.set(state.assignmentRequests, idx, {
      ...state.assignmentRequests[idx],
      description: request.description,
      error: request.error,
      progress: request.progress,
    })
  },
}

export const MassReassignmentGetters = {
  assignmentRequests: state => state.assignmentRequests.filter(r => !!r.visible),
}

export const MASS_REASSIGNMENT_NAMESPACE = 'mass-reassignment'

export const MassReassignment = {
  namespaced: true,
  state: MassReassignmentState,
  actions: MassReassignmentActions,
  mutations: MassReassignmentMutations,
  getters: MassReassignmentGetters,
}
